module.exports = __webpack_public_path__ + "static/media/signin-background-light.41adee85.jpg";